/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {KTSVG} from '../../../_metronic/helpers'
import {Dropdown1} from '../../../_metronic/partials'
import {AccountSetupWidget} from '../../../_metronic/partials/widgets'
import {getDashboardData, getRevenueDetails} from './Dashboard_API'
import {useAuth} from '../../modules/auth'
import Swal from 'sweetalert2'
import {CircularProgress} from '@mui/material'
// import '././Dashboard_styles/dashboard_styles.css'
import './Dashboard_styles/dashboardStyles.css'

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const [loading, setLoading] = useState(true)
  const [dashboardData, setDashboardData] = useState({
    properties: {
      active: 0,
      blocked: 0,
      total: 0,
    },
    users: {
      total: 0,
    },
    occupency: {
      occupencyPercentage: 0,
    },
    setup_flow: {
      basic_details: false,
      invoice: false,
      property_add: false,
      reports_download: false,
      subscription_plan: false,
      team_memebers: true,
      tenants: false,
    },
  })
  const [revenueData, setRevenueData] = useState({
    data: {
      overDueRevenue: 0,
      revenuePaid: 0,
      revenuePending: 0,
      totalRevenue: 0,
    },
  })
  const {currentUser} = useAuth()
  async function getDashboard() {
    setLoading(true)
    try {
      const response1 = await getDashboardData()
      if (response1.status === 200) {
        setDashboardData(response1.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong',
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }

  async function getRevenue() {
    setLoading(true)
    try {
      const response = await getRevenueDetails()
      if (response.status === 200) {
        setRevenueData(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong',
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }

  console.log('revenue', revenueData)

  useEffect(() => {
    getDashboard()
    getRevenue()
  }, [])

  const handleVerifyProfileMsg = (account_verified: number | undefined) => {
    switch (account_verified) {
      case 0:
        return 'Please verify email address and phone number'
      case 1:
        return 'Please verify phone number'
      case 2:
        return 'Please verify email address'
      default:
        return 'Please verify your credentials'
    }
  }
  const calculateCompletion = (data: any) => {
    let trueCount = 0

    for (const key in data) {
      if (data.hasOwnProperty(key) && data[key] === true) {
        trueCount++
      }
    }

    const percentage = (trueCount / Object.keys(data).length) * 100
    const roundedPercentage = percentage.toFixed(0)
    return roundedPercentage
  }

  let userType = localStorage.getItem('user_type')
  return loading ? ( // {* Begin: loader*}
    <div
      className='d-flex justify-content-center align-items-center vh-70'
      style={{height: '70vh'}}
    >
      <CircularProgress />
    </div>
  ) : (
    // {* End: loader*}
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.HOME'})}</PageTitle> */}
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                      Welcome back, {currentUser?.accouont_holder_name}
                    </a>
                    <a href='#'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen026.svg'
                        className='svg-icon-1 svg-icon-primary'
                      />
                    </a>
                  </div>

                  <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                    <a
                      href='#'
                      className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                    >
                      <KTSVG
                        path='/media/icons/duotune/communication/com011.svg'
                        className='svg-icon-4 me-1'
                      />
                      {currentUser?.email_id}
                    </a>
                  </div>
                </div>

                <div className='d-flex flex-column'>
                  {currentUser?.account_verified !== 3 && (
                    <p className='mb-1 text-muted fs-6 fw-bold'>
                      {handleVerifyProfileMsg(currentUser?.account_verified)}
                    </p>
                  )}

                  <Link
                    to='/update-profile'
                    className='btn btn-sm btn-primary me-3 '
                    // data-bs-toggle='modal'
                    // data-bs-target='#kt_modal_offer_a_deal'
                  >
                    {calculateCompletion(dashboardData.setup_flow) === '100'
                      ? 'View Profile'
                      : 'Complete Profile'}
                    {/* {Complete Profile"} */}
                  </Link>
                  {/* <a href='#' className='btn btn-sm btn-light me-2' id='kt_user_follow_button'>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr012.svg'
                      className='svg-icon-3 d-none'
                    />

                    <span className='indicator-label'>View Reports</span>
                    <span className='indicator-progress'>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </a> */}
                  {/* <div className='me-0'>
                    <button
                      className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                      data-kt-menu-trigger='click'
                      data-kt-menu-placement='bottom-end'
                      data-kt-menu-flip='top-end'
                    >
                      <i className='bi bi-three-dots fs-3'></i>
                    </button>
                    <Dropdown1 />
                  </div> */}
                </div>
              </div>
              {userType !== 'Tenant' && (
                <>
                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                        <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr066.svg'
                              className='svg-icon-3 svg-icon-success me-2'
                            />
                            <div className='fs-2 fw-bolder'>{dashboardData.properties.active}</div>
                          </div>

                          <div className='fw-bold fs-6 text-gray-400'>Active Properties</div>
                        </div>

                        <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr065.svg'
                              className='svg-icon-3 svg-icon-danger me-2'
                            />
                            <div className='fs-2 fw-bolder'>{dashboardData.users.total}</div>
                          </div>

                          <div className='fw-bold fs-6 text-gray-400'>Users</div>
                        </div>

                        <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr066.svg'
                              className='svg-icon-3 svg-icon-success me-2'
                            />
                            <div className='fs-2 fw-bolder'>
                              {dashboardData.occupency.occupencyPercentage}%
                            </div>
                          </div>

                          <div className='fw-bold fs-6 text-gray-400'>Occupancy</div>
                        </div>
                      </div>
                    </div>

                    <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                      <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                        <span className='fw-bold fs-6 text-gray-400'>
                          Account Setup Completion{' '}
                        </span>
                        <span className='fw-bolder fs-6'>
                          {calculateCompletion(dashboardData.setup_flow)}%
                        </span>
                      </div>
                      <div className='h-5px mx-3 w-100 bg-light mb-3'>
                        <div
                          className='bg-success rounded h-5px'
                          role='progressbar'
                          style={{width: `${calculateCompletion(dashboardData.setup_flow)}%`}}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className='py-5'>
                    <div className='g-2 mb-2 row row-cols-1 row-cols-lg-4 row-cols-sm-2'>
                      {revenueData?.data?.revenuePaid !== null && (
                        <div className='col position-relative'>
                          <div className='card flex-row p-5 border border-gray-300 border-dashed rounded'>
                            <i className='bg-opacity-75 bg-primary h-10 me-3 rounded w-0.5 blurred-content'></i>
                            <div className='flex-grow-1 lh-1 text-body-emphasis blurred-content'>
                              {/* <div
                              className='align-items-center badge bg-success d-inline-flex float-end fs-8 rounded-pill text-success-emphasis'
                              style={{'--bs-bg-opacity': '.1'} as React.CSSProperties}
                            >
                              <i className='fs-6 me-1 ph ph-arrow-circle-up'></i> 2.23%
                            </div> */}
                              <div className='fs-4 mb-2 me-2 text-warning'>
                                {revenueData?.data?.overDueRevenue}
                              </div>{' '}
                              Overdue
                            </div>
                          </div>
                          <div className='position-absolute top-50 start-50 translate-middle overlay-text'>
                            Coming Soon
                          </div>
                        </div>
                      )}
                      {/*                     
                      {revenueData?.data?.revenuePaid !== null &&   
                      <div className='col'>
                        <div className='card flex-row p-5 border border-gray-300 border-dashed rounded'>
                          <i className='bg-danger bg-opacity-75 h-10 me-3 rounded w-0.5'></i>
                          <div className='flex-grow-1 lh-1 text-body-emphasis'>
                           
                            <div className='fs-4 mb-2 me-2 text-success'>{revenueData?.data?.revenuePaid}</div>
                            Revenue Paid
                          </div>
                        </div>
                      </div>
                      } */}

                      {revenueData?.data?.revenuePaid !== null && (
                        <div className='col position-relative'>
                          <div className='card flex-row p-5 border border-gray-300 border-dashed rounded'>
                            <i className='bg-danger bg-opacity-75 h-10 me-3 rounded w-0.5 blurred-content'></i>
                            <div className='flex-grow-1 lh-1 text-body-emphasis blurred-content'>
                              <div className='fs-4 mb-2 me-2 text-success blurred-content'>
                                {revenueData?.data?.revenuePaid}
                              </div>
                              Paid
                            </div>
                          </div>
                          {/* Coming Soon Overlay */}
                          <div className='position-absolute top-50 start-50 translate-middle overlay-text'>
                            Coming Soon
                          </div>
                        </div>
                      )}

                      {revenueData?.data?.revenuePending !== null && (
                        <div className='col position-relative'>
                          <div className='card flex-row p-5 border border-gray-300 border-dashed rounded'>
                            <i className='bg-opacity-75 bg-success h-10 me-3 rounded w-0.5 blurred-content'></i>
                            <div className='flex-grow-1 lh-1 text-body-emphasis blurred-content'>
                              {/* <div
                            className='align-items-center badge bg-success d-inline-flex float-end fs-8 rounded-pill text-success-emphasis'
                            style={{'--bs-bg-opacity': '.1'} as React.CSSProperties}
                          >
                            <i className='fs-6 me-1 ph ph-arrow-circle-up'></i> 5.32%
                          </div> */}
                              <div className='fs-4 mb-2 me-2 text-danger blurred-content'>
                                {revenueData?.data?.revenuePending}
                              </div>{' '}
                              Pending
                            </div>
                          </div>
                          <div className='position-absolute top-50 start-50 translate-middle overlay-text'>
                            Coming Soon
                          </div>
                        </div>
                      )}

                      {revenueData?.data?.totalRevenue !== null && (
                        <div className='col'>
                          <div className='card flex-row p-5 border border-gray-300 border-dashed rounded'>
                            <i className='bg-opacity-75 bg-warning h-10 me-3 rounded w-0.5'></i>
                            <div className='flex-grow-1 lh-1 text-body-emphasis'>
                              {/* <div
                              className='align-items-center badge bg-danger d-inline-flex float-end fs-8 rounded-pill text-danger-emphasis'
                              style={{'--bs-bg-opacity': '.15'} as React.CSSProperties}
                            >
                              <i className='fs-6 me-1 ph ph-arrow-circle-up'></i> 0.98%
                            </div> */}
                              <div className='fs-4 mb-2 me-2 text-info'>
                                {revenueData?.data?.totalRevenue}
                              </div>{' '}
                              Total Revenue
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {userType !== 'Tenant' && (
        <AccountSetupWidget setupData={dashboardData.setup_flow} className='mb-5 mb-xxl-8' />
      )}
    </>
  )
}

export {DashboardWrapper}
